import { Avatar, Box, type IColumn, Typography } from 'shared/ui'
import { getUserAvatarColor } from 'entities/Users/lib/getUserAvatarColor'
import { type MemberRow } from 'pages/settings/pages/teams/ui/ManageTeamMembers/MemberRow'
import styles from './styles.module.scss'

export const getMembersTableColumns = (): IColumn<MemberRow>[] => [
  {
    field: 'fullName',
    name: 'Name',
    isSortable: true,
    renderRowCell: (row) => (
      <Box display='flex' alignItems='center' gap='10px' minHeight='57px'>
        <Avatar
          size={32}
          info={{
            firstName: row.origin.first_name,
            lastName: row.origin.last_name,
            image: row.origin.photo_url ?? '',
            color: getUserAvatarColor(row.origin.id),
          }}
        />
        <div className={styles.nameInfo}>
          <Typography
            ellipsis
            variant='body-md-regular'
            ariaLabel='ManageTeamMembersMemberFullName'
          >
            {row.fullName}
          </Typography>
          <Typography
            ellipsis
            color='var(--content-primary-tertiary)'
            variant='body-sm-regular'
            ariaLabel='ManageTeamMembersMemberEmail'
          >
            {row.email}
          </Typography>
        </div>
      </Box>
    ),
  },
]
